export const userOsIdentifier = () => {
  let OsPlatform: string;
  if (navigator?.platform) {
    OsPlatform = navigator?.platform?.toLowerCase();
  } else if (navigator?.userAgent) {
    OsPlatform = navigator?.userAgent?.toLowerCase();
  } else {
    return 'windows';
  }
  if (OsPlatform?.includes('mac')) {
    return 'mac';
  }
  return 'windows';
};

export const getAiSearchShortcut = (
  detectedDeviceForAiSearch: 'mac' | 'windows' | '',
) => {
  if (detectedDeviceForAiSearch === 'mac') {
    return '⌘ K';
  }
  return 'Ctrl+K';
};

export const placeholderSuggestions = [
  'Find me people from investment banking in the US.',
  'Find Silicon Valley CEOs with fewer than 50 staff.',
  'Find HR professionals working in startups under 200 employees.',
  'Find SEO specialists with 10+ years of experience.',
];

export const aiSuggestions = [
  'Find Silicon Valley CEOs with fewer than 50 staff.',
  'Find HR professionals working in startups with fewer than 200 employees.',
];

export const getUserRecentSearches = (userEmail?: string): any[] => {
  if (!userEmail) return [];

  try {
    const recentSearches = JSON.parse(
      localStorage?.getItem('aiSearchHistory') || '[]',
    );
    return recentSearches?.[userEmail] || [];
  } catch (error) {
    console.error('Failed to parse aiSearchHistory from localStorage', error);
    return [];
  }
};
